import { render, staticRenderFns } from "./MenuCmp.vue?vue&type=template&id=1ef723b1&lang=pug&"
import script from "./MenuCmp.vue?vue&type=script&lang=js&"
export * from "./MenuCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports